import type { Segment } from '../types'

// Emits a Heap event when a recommended query (one backed by a
// partner_segment_id) finishes loading, so the product team can track which
// recommended queries are actually being used. The firm and current user
// (id/email) are already attached to every event by heap.identify /
// heap.addUserProperties in the Heap init (layouts/trackers/_heap.html.erb),
// so only the query-specific properties are sent here. segmentName is sent
// in English (name_en) so the event is comparable across user locales.
export function trackRecommendedQueryLoaded(segment: Segment | null): void {
  if (!segment?.partner_segment_id) return
  if (!window.heap) return

  window.heap.track('insights.recommended_query', {
    partnerSegmentId: String(segment.partner_segment_id),
    segmentName: segment.name_en || segment.name,
  })
}
